import { Box } from '@mui/material'
import React, { ComponentType, MutableRefObject } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import IconButtonWithTooltip from '../IconButtonWithTooltip'
import { copyBase64ToClipboard, downloadBase64Image } from 'app/helpers'
// @ts-ignore
import { useScreenshot } from 'use-react-screenshot'

const useStyles = makeStyles((theme) => ({}))

type Props = {
  chartContainerRef?: MutableRefObject<ComponentType>
}

const ChartTooltip = (props: Props) => {
  const { chartContainerRef } = props
  const { 1: takeScreenshot } = useScreenshot()
  const classes = useStyles()

  if (!chartContainerRef?.current) {
    return null
  }

  const copyAsImage = () => {
    takeScreenshot(chartContainerRef.current).then(copyBase64ToClipboard)
  }
  const downloadAsImage = () => {
    takeScreenshot(chartContainerRef.current).then((base64: string) =>
      downloadBase64Image(base64, {
        name: 'chart.png',
      })
    )
  }
  return (
    <Box display={'flex'} className={'pl-2 mb-1'}>
      <IconButtonWithTooltip
        tooltip="Download as image"
        iconName="photo_camera"
        onClick={downloadAsImage}
      />
      <IconButtonWithTooltip
        tooltip="Copy as image"
        iconName="content_copy"
        onClick={copyAsImage}
      />
    </Box>
  )
}

export default ChartTooltip
